<div class="row conteneur-contacter-ma-caf-par-courriel-cnaf" id="conteneur-contacter-ma-caf-par-courriel-cnaf">
    <div class="col-sm-12">
        <h3 class="titre-bloc-cnaf filet-cnaf text-uppercase titre-gris" tabindex="-1">
            Par mail
        </h3>
    </div>
    <div class="col-sm-12" [ngSwitch]="etat">
        <div *ngSwitchCase="'loading'" class="progress">
            <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar">
                Chargement en cours...
            </div>
        </div>
        <div *ngSwitchCase="'error'">
            <div class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-alert"></span>
                <p class="inline-cnaf">Un incident technique s'est produit.
                <br aria-hidden="true"/>Merci de renouveler votre démarche.</p>
            </div>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a routerLink="/contactcaf" routerLinkActive="active" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    <span class="btn-block">Retour Contacter ma Caf</span>
                </a>
            </div>
        </div>
        <div *ngSwitchCase="'nonAutorise'">
            <div class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-alert"></span>
                <p class="inline-cnaf">Vous n'êtes pas autorisé à envoyer un mail.</p>
            </div>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a routerLink="/contactcaf" routerLinkActive="active" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    <span class="btn-block">Retour Contacter ma Caf</span>
                </a>
            </div>
        </div>
        <div *ngSwitchCase="'emailVide'">
            <div class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-alert"></span>
                <p class="inline-cnaf">Vous n'avez pas communiqué votre adresse mail. Il vous faut renseigner ces informations avant d'écrire à votre Caf.</p>
            </div>
            <div class="col-sm-4 col-xs-6 pull-left">
                <a href="/redirect/s/Redirect?page=changementAdresseCourriel" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    Renseigner votre adresse mail
                </a>
            </div>
            <div class="col-sm-4 col-xs-6 pull-right">
                <a routerLink="/contactcaf" routerLinkActive="active"  class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                    Retour Contacter ma Caf
                </a>
            </div>
        </div>
        <form name="contacterMaCafForm" class="clearfix small-padding"  [formGroup]="myForm" #contaterParCourrielNgForm="ngForm" (ngSubmit)="onFormSubmit()" autocomplete="off"> 
            <div class="noprint" *ngSwitchCase="loadedOrReponsesCamille()">
                <div>
                    <p class="texte-info-cnaf">Tous les champs sont obligatoires, sauf mention contraire.</p>
                </div>
                <div>
                    <label class="label-form-cnaf">Complétez le formulaire ci-dessous</label>
                    <p>Attention, si vous venez de déclarer un changement de situation sur Caf.fr, ces informations peuvent ne pas s'afficher instantanément sur cette page.
                        <span *ngIf="!isCamilleAutorisee ||
                            (isCamilleAutorisee && selObjetMessage.code=='INFO_REC')">
                            <br/>Cependant, vous pouvez adresser un mail à votre Caf via le formulaire ci-dessous.
                        </span>
                    </p>
                </div>
                
                <div class="form-group">
                    <label class="label-form-cnaf">Merci de vérifier vos coordonnées</label>
                    <div class="hidden-xs">
                        <label class="label-courriel-cnaf-desktop">Votre adresse mél : <span class="text-primary" [textContent]="email"></span></label>
                        <button type="button"(click)="redirect('/redirect/s/Redirect?page=changementAdresseCourriel')" class="btn btn-form-cnaf btn-secondaire-cnaf pull-right">
                            Modifier
                        </button>
                    </div>
                    <div class="visible-xs">
                        <label class="label-courriel-cnaf-mobile">Votre adresse mél :<br/>
                            <a href="/redirect/s/Redirect?page=changementAdresseCourriel">
                                <span class="text-primary"  [textContent]="email"></span>
                                <img src="/icfstatiquesangularappli/dist/images/usager/pic_modifier.png" alt="Modifier"/>
                            </a>
                        </label>
                    </div>
                </div>
   
                <div class="form-group" [ngClass]="{'has-error': (submitted || myForm.controls['selObjetMessage'].touched) && myForm.controls['selObjetMessage'].errors }">
                    <div class="dropdown-cnaf">
                        <label class="label-form-cnaf" for="idObjetMsg">Merci de choisir votre motif :</label>
                        <br/>
                        <select
                            name="objetMessage"
                            id="idObjetMsg"
                            class="form-control select-cnaf"
                            required
                            (change)="updateObjet()"
                            [attr.disabled]="(chargementMotif ||
                            ((currentRoute() === '/contactcafcourriel/reponses') && !selObjetMessage.hasChildren)) ? 'true':null"
                            aria-describedby="selObjetMessageHelp selObjetMessageErreur"
                            formControlName="selObjetMessage">
                            <option value="" selected disabled='disabled'>--- Sélectionnez dans la liste... ---</option>
                            <option class="hidden-xs" [ngValue]="objetMessage" *ngFor="let objetMessage of listeObjetMessage" [attr.disabled]="!objetMessage.selectionnable ?  'disabled' : null">{{objetMessage.libelleCaffr}}</option>
                            <option class="visible-xs" [ngValue]="objetMessage" *ngFor="let objetMessage of listeObjetMessage" [attr.disabled]="!objetMessage.selectionnable ?  'disabled' : null">{{objetMessage.libelleMobile}}</option>
                        </select>
                        <span class="sr-only" id="selObjetMessageHelp">Champ obligatoire</span>
                        <div id="selObjetMessageErreur" *ngIf="!(myForm.controls.selObjetMessage.errors && (submitted || myForm.controls.selObjetMessage.touched))" ></div>
                        <div role="alert" *ngIf="(submitted || myForm.controls['selObjetMessage'].touched) && myForm.controls['selObjetMessage'].errors" class="help-block">
                            <p *ngIf="myForm.controls['selObjetMessage'].errors?.required" id="selObjetMessageErreur">Champ obligatoire</p>
                        </div>
                    </div>
                </div>
               
                <div class="form-group" *ngIf="isCamilleAutorisee"
                    [hidden]="!selObjetMessage ||
                    !(selObjetMessage.code != 'INFO_REC') ||
                    selObjetMessage.hasChildren ||
                    selObjetMessageIsEmptyJson">
                    <br/>
                    <cnaf-camille-header></cnaf-camille-header>
                </div>

                <div [hidden]="!selObjetMessage.hasChildren">

                    <div class="row conteneur-aide-camille">
                        <div class="col-sm-12">
                            <div class="message-cnaf">
                                <div class="mise-en-avant-fond-cnaf">
                                    <p><strong>Besoin de plus d'informations avant de nous contacter ?</strong>
                                    <br aria-hidden="true"/>Pour répondre au mieux à votre demande, nous vous proposons une série de choix qui correspondent aux différentes situations du motif sélectionné.
                                    <br aria-hidden="true"/>Si vous ne trouvez pas votre réponse parmi nos propositions d'articles, vous pourrez écrire et envoyer un mail à votre Caf.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row conteneur-motif-camille" [hidden]="!selObjetMessage.hasChildren">
                        <div class="col-xs-12 form-group">
                            <label class="label-form-cnaf">Quelle est votre situation ?</label>
                            <div class="row">
                                <div class="form-group btn-group-lg-cnaf" ngCnafRadioGroup formControlName="motif1">
                                    <div class="col-xs-12 col-sm-4" *ngFor="let motif1 of selObjetMessage.children">
                                        <label class="btn btn-default btn-block align-middle-cnaf"
                                            for="{{'Motif_' + motif1.idProduit}}"
                                            (change)="checkSousMotif(motif1, 1)"
                                            [attr.disabled]="chargementMotif ? 'disabled' : null"
                                            ngCnafButtonLabel>
                                            <span aria-hidden="true">{{motif1.libelle}}</span>
                                            <input type="radio" name="{{'Motif_' + motif1.idProduit}}"
                                                [attr.aria-label]="motif1.libelle"
                                                class="sr-only" [attr.id]="'Motif_' + motif1.idProduit"
                                                [attr.disabled]="chargementMotif ? 'disabled' : null"
                                                ngCnafButton
                                                [value]="motif1">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row conteneur-motif-camille" [hidden]="!motif1.hasChildren">
                        <div class="col-xs-12 form-group">
                            <label class="label-form-cnaf">Votre demande concerne :</label>
                            <div class="row">
                                <div class="form-group btn-group-lg-cnaf" ngCnafRadioGroup formControlName="motif2">
                                    <div class="col-xs-12 col-sm-4" *ngFor="let motif2 of motif1.children">
                                        <label class="btn btn-default btn-block align-middle-cnaf"
                                            for="{{'Motif_' + motif2.idProduit}}"
                                            (change)="checkSousMotif(motif2, 2)"
                                            [attr.disabled]="chargementMotif ? 'disabled' : null"
                                            ngCnafButtonLabel>
                                            <span aria-hidden="true">{{motif2.libelle}}</span>
                                            <input type="radio" name="{{'Motif_' + motif2.idProduit}}"
                                                [attr.aria-label]="motif2.libelle"
                                                class="sr-only" [attr.id]="'Motif_' + motif2.idProduit"
                                                [attr.disabled]="chargementMotif ? 'disabled' : null"
                                                ngCnafButton
                                                [value]="motif2">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row conteneur-motif-camille" [hidden]="!motif2.hasChildren">
                        <div class="col-xs-12 form-group">
                            <label class="label-form-cnaf">Au sujet de :</label>
                            <div class="row">
                                <div class="form-group btn-group-lg-cnaf" ngCnafRadioGroup formControlName="motif3">
                                    <div class="col-xs-12 col-sm-4" *ngFor="let motif3 of motif2.children">
                                        <label class="btn btn-default btn-block align-middle-cnaf"
                                            for="{{'Motif_' + motif3.idProduit}}"
                                            (change)="checkSousMotif(motif3, 3)"
                                            [attr.disabled]="chargementMotif ? 'disabled' : null"
                                            ngCnafButtonLabel>
                                            <span aria-hidden="true">{{motif3.libelle}}</span>
                                            <input type="radio" name="{{'Motif_' + motif3.idProduit}}"
                                                [attr.aria-label]="motif3.libelle"
                                                class="sr-only" [attr.id]="'Motif_' + motif3.idProduit"
                                                [attr.disabled]="chargementMotif ? 'disabled' : null"
                                                ngCnafButton
                                                [value]="motif3">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row conteneur-motif-camille" [hidden]="!motif3.hasChildren">
                        <div class="col-xs-12 form-group">
                            <label class="label-form-cnaf">Au sujet de :</label>
                            <div class="row">
                                <div class="form-group btn-group-lg-cnaf" ngCnafRadioGroup formControlName="motif4">
                                    <div class="col-xs-12 col-sm-4" *ngFor="let motif4 of motif3.children">
                                        <label class="btn btn-default btn-block align-middle-cnaf"
                                            for="{{'Motif_' + motif4.idProduit}}"
                                            (change)="checkSousMotif(motif4, 4)"
                                            [attr.disabled]="chargementMotif ? 'disabled' : null"
                                            ngCnafButtonLabel>
                                            <span aria-hidden="true">{{motif4.libelle}}</span>
                                            <input type="radio" name="{{'Motif_' + motif4.idProduit}}"
                                                [attr.aria-label]="motif4.libelle"
                                                class="sr-only" [attr.id]="'Motif_' + motif4.idProduit"
                                                [attr.disabled]="chargementMotif ? 'disabled' : null"
                                                ngCnafButton
                                                [value]="motif4">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row conteneur-motif-camille" [hidden]="!motif4.hasChildren">
                        <div class="col-xs-12 form-group">
                            <label class="label-form-cnaf">Au sujet de : </label>
                            <div class="row">
                                <div class="form-group btn-group-lg-cnaf"  ngCnafRadioGroup formControlName="motif5">
                                    <div class="col-xs-12 col-sm-4" *ngFor="let motif5 of motif4.children">
                                        <label class="btn btn-default btn-block align-middle-cnaf"
                                            for="{{'Motif_' + motif5.idProduit}}"
                                            (change)="checkSousMotif(motif5, 5)"
                                            [attr.disabled]="chargementMotif ? 'disabled' : null"
                                            ngCnafButtonLabel>
                                            <span aria-hidden="true">{{motif5.libelle}}</span>
                                            <input type="radio" name="{{'Motif_' + motif5.idProduit}}"
                                                [attr.aria-label]="motif5.libelle"
                                                class="sr-only" [attr.id]="'Motif_' + motif5.idProduit"
                                                [attr.disabled]="chargementMotif ? 'disabled' : null"
                                                ngCnafButton
                                                [value]="motif5">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>               
                </div>
                <div *ngIf="chargementMotif" class="progress chargement-motif-cnaf">
                    <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar">
                        Chargement en cours...
                    </div>
                </div>   
                <div class="form-group" [ngClass]="{'has-error': (submitted || myForm.controls['selMotifReclamation'].touched) && myForm.controls['selMotifReclamation'].errors }" [hidden]="!(selObjetMessage.code=='INFO_REC')">
                    <div class="dropdown-cnaf">
                        <label class="label-form-cnaf" for="idMotifReclamation">Votre réclamation concerne</label>
                        <div>
                        <select
                            name="motifReclamation"
                            id="idMotifReclamation"
                            class="form-control select-cnaf"
                            [attr.required]="(selObjetMessage.code=='INFO_REC') ? 'required' : null"
                            formControlName="selMotifReclamation"
                            aria-describedby="selMotifReclamationHelp selMotifReclamationErreur"
                            >
                            <option value="" selected disabled='disabled'>--- Sélectionnez dans la liste... ---</option>
                            <option class="hidden-xs" [ngValue]="motifReclamation" *ngFor="let motifReclamation of listeMotifReclamation" [attr.disabled]="!motifReclamation.selectionnable? 'disabled' : null">{{motifReclamation.libelleCaffr}}</option>
                            <option class="visible-xs" [ngValue]="motifReclamation" *ngFor="let motifReclamation of listeMotifReclamation" [attr.disabled]="!motifReclamation.selectionnable? 'disabled' : null">{{motifReclamation.libelleMobile}}</option>
                        </select>
                        </div>
                    </div>
                    <span class="sr-only" id="selMotifReclamationHelp">Champ obligatoire</span>
                    <div id="selMotifReclamationErreur" *ngIf="!(myForm.controls.selMotifReclamation.errors && (submitted || myForm.controls.selMotifReclamation.touched))" ></div>
                    <div role="alert" *ngIf="(submitted || myForm.controls['selMotifReclamation'].touched) && myForm.controls['selMotifReclamation'].errors" class="help-block">
                        <p *ngIf="myForm.controls['selMotifReclamation'].errors?.required" id="selMotifReclamationErreur">Champ obligatoire</p>
                    </div>
                </div>
                <div class="form-group" [ngClass]="{'has-error': (submitted || myForm.controls['selPrestation'].touched) && myForm.controls['selPrestation'].errors }" [hidden]="!(selObjetMessage.code=='INFO_REC' && selMotifReclamation.famille=='dossier')">
                    <div class="dropdown-cnaf" >
                        <label class="label-form-cnaf" for="idPrestation">Votre réclamation concerne une prestation</label>
                        <div>
                        <select
                            name="prestation"
                            id="idPrestation"
                            class="form-control select-cnaf"
                            [attr.required]="(selObjetMessage.code=='INFO_REC' && selMotifReclamation.famille=='dossier') ? 'required' : null"
                            formControlName="selPrestation"
                            aria-describedby="selPrestationHelp selPrestationErreur">
                            <option value="" selected disabled='disabled'>--- Sélectionnez dans la liste... ---</option>
                            <option class="hidden-xs" [ngValue]="prestation" *ngFor="let prestation of listePrestation" [attr.disabled]="!prestation.selectionnable? 'disabled' : null">{{prestation.libelleCaffr}}</option>
                            <option class="visible-xs" [ngValue]="prestation" *ngFor="let prestation of listePrestation" [attr.disabled]="!prestation.selectionnable? 'disabled' : null">{{prestation.libelleMobile}}</option>
                        </select>
                        </div>
                    </div>
                    <span class="sr-only" id="selPrestationHelp">Champ obligatoire</span>
                    <div id="selPrestationErreur" *ngIf="!(myForm.controls.selPrestation.errors && (submitted || myForm.controls.selPrestation.touched))" ></div>
                    <div role="alert" *ngIf="(submitted || myForm.controls['selPrestation'].touched) && myForm.controls['selPrestation'].errors" class="help-block">
                        <p *ngIf="myForm.controls['selPrestation'].errors?.required" id="selPrestationErreur">Champ obligatoire</p>
                    </div>
                </div>
                <div [hidden]="!(selObjetMessage && !selObjetMessageIsEmptyJson && !selObjetMessage.hasChildren)">
                    <div class="form-group" [ngClass]="{'has-error': (submitted || myForm.controls['messageCourriel'].touched) && myForm.controls['messageCourriel'].errors }">
                        <div [hidden]="isCamilleAutorisee &&
                            !(isCamilleAutorisee && selObjetMessage.code=='INFO_REC')">
                            <label class="label-form-cnaf" for="idMessage">Votre message</label>
                            <div>
                            <textarea class="form-control textarea-courriel-cnaf" id="idMessage" rows="5"
                                name="messageCourriel"
                                placeholder="Saisissez votre message..."
                                [attr.aria-invalid]="!messageCourriel.trim()"
                                formControlName="messageCourriel"
                                [attr.required]="(!isCamilleAutorisee ||
                                (isCamilleAutorisee && selObjetMessage.code=='INFO_REC')) ? 'required' : null"
                                aria-describedby="messageCourrielHelp messageCourrielErreur">
                            </textarea>
                            <span class="sr-only" id="messageCourrielHelp">Champ obligatoire</span>
                            <div id="messageCourrielErreur" *ngIf="!(myForm.controls.messageCourriel.errors && (submitted || myForm.controls.messageCourriel.touched))" ></div>
                            <div role="alert" *ngIf="(submitted || myForm.controls['messageCourriel'].touched) && myForm.controls['messageCourriel'].errors" class="help-block">
                                <p *ngIf="myForm.controls['messageCourriel'].errors?.required" id="messageCourrielErreur">Champ obligatoire</p>
                              </div>
                            </div>
                        </div>
                        <div *ngIf="isCamilleAutorisee"
                            [hidden]="!(selObjetMessage.code!='INFO_REC' &&
                            !selObjetMessage.hasChildren)">
                            <label class="label-form-cnaf" for="idQuestion">
                                Posez votre question en quelques mots &nbsp;
                                <span class="texte-clair-cnaf texte-info-italic-cnaf">
                                    <br>
                                    Attention, Camille ne répond pas aux questions personnalisées sur le dossier.
                                </span> 
                                <ng-cnaf-aide idDiv="content-popover" alt="Informations Camille"></ng-cnaf-aide>    
                            </label>
                            <div class="hidden" id="content-popover" role="tooltip">
                                <div class="popover-btn-close-cnaf"></div>
                                <p>Cet espace est destiné à une question courte.</p>
                                <p>Camille ne peut pas donner d'informations personnalisées sur votre dossier.</p>
                                <p>Si les réponses ne vous conviennent pas, à l'étape suivante, vous pourrez écrire votre mail et l'envoyer à votre Caf.</p>
                            </div>
                            <div [ngClass]="{'has-error': (submitted || myForm.controls['questionCamille'].touched) && myForm.controls['questionCamille'].errors }">
                            <textarea class="form-control textarea-question-cnaf" [ngClass]="{ 'has-readonly' : (currentRoute() === '/contactcafcourriel/reponses') }"
                                id="idQuestion"
                                rows="2"
                                
                                name="questionCamille"
                                placeholder="Cet espace est réservé à une question courte (ex. : comment faire une demande de prime d'activité ?)."
                                [attr.aria-invalid]="!questionCamille"
                                aria-describedby="questionCamilleHelp questionCamilleErreur"
                                maxlength="150"
                                
                                formControlName="questionCamille"
                                [readonly]="(currentRoute() === '/contactcafcourriel/reponses')"
                                [attr.required]="(isCamilleAutorisee &&
                                (selObjetMessage.code!='INFO_REC') &&
                                !selObjetMessage.hasChildren) ? 'required' : null">
                            </textarea>
                            <span class="sr-only" id="questionCamilleHelp">Champ obligatoire 150 caractères maximum</span>
                            <div id="questionCamilleErreur" *ngIf="!(myForm.controls.questionCamille.errors && (submitted || myForm.controls.questionCamille.touched))" ></div>
                            <div role="alert" *ngIf="(submitted || myForm.controls['questionCamille'].touched) && myForm.controls['questionCamille'].errors" class="help-block">
                                <p *ngIf="myForm.controls['questionCamille'].errors?.required" id="questionCamilleErreur">Champ obligatoire</p>
                              </div>
                            </div>
                        </div>
                    </div>
                    
                    <div [hidden]="(currentRoute() === '/contactcafcourriel/reponses')">
                        <div id="idErreurQuestion" *ngIf="!((isCamilleAutorisee && selObjetMessage.code!='INFO_REC' && !selObjetMessage.hasChildren) &&
                            (myForm.controls['questionCamille'].touched || myForm.controls['questionCamille'].dirty))"></div>
                        <div role="alert" *ngIf="(isCamilleAutorisee && selObjetMessage.code!='INFO_REC' && !selObjetMessage.hasChildren) &&
                            (myForm.controls['questionCamille'].touched || myForm.controls['questionCamille'].dirty)" class="no-padding-cnaf">
                            <p id="idErreurQuestion" class="message-cnaf-erreur" *ngIf="questionCamille.length >= 150 && !myForm.controls.questionCamille.errors?.required">Vous avez atteint la limite de saisie de texte.</p>
                        </div>
                    </div>
                    <div role="note" [hidden]="(currentRoute() === '/contactcafcourriel/reponses')">
                		<ul class="no-padding-cnaf" *ngIf="(isCamilleAutorisee &&
                            selObjetMessage.code!='INFO_REC' && !selObjetMessage.hasChildren) &&
                            (!questionCamille || questionCamille.length < 150)">
                			<li id="idInfoQuestion" class="message-cnaf-info texte-info-italic-cnaf">
                                {{150 - questionCamille.length}}
                                <span *ngIf="questionCamille.length < 149 || !questionCamille">
                                    caractères restants.
                                </span>
                                <span *ngIf="questionCamille.length > 148">
                                    caractère restant.
                                </span>
                            </li>
                		</ul>
                    </div>
                </div>
            </div>
            <div *ngSwitchCase="'postFormOk'">
                <p class="">Votre message a été transmis à la
                    {{nomCaf}}.
                    <br/>
                    Il sera traité dans les meilleurs délais.
                </p>
            </div>
            <div *ngSwitchCase="'postFormKo'">
                <div class="alert alert-danger" role="alert">
                    <span class="glyphicon glyphicon-alert"></span>
                    <p class="inline-cnaf">Suite à un incident technique, votre message n'a pas pu nous être transmis.
                    <br aria-hidden="true"/>Merci de réessayer plus tard.</p>
                </div>
                <div class="col-sm-4 col-xs-6 pull-left">
                    <a href="/redirect/s/Redirect?page=monCompte" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                        <span class="">Retour accueil</span>
                    </a>
                </div>
            </div>
            <div *ngSwitchCase="'postFormOk'">
                <div class="col-sm-4 col-xs-6 pull-left">
                    <a href="/redirect/s/Redirect?page=monCompte" class="btn btn-form-cnaf btn-block btn-active-cnaf text-center align-middle-cnaf">
                        <span class="">Retour accueil</span>
                    </a>
                </div>
            </div>
            
            <div *ngSwitchCase="loadedOrReponsesCamille()">
                <div class="form-group text-center"
                    [hidden]="(currentRoute() === '/contactcafcourriel/reponses') && !((currentRoute() === '/contactcafcourriel/reponses') && selObjetMessage.code=='INFO_REC')">
                    <br/>
                    <p [hidden]="!selObjetMessage || selObjetMessageIsEmptyJson || (isCamilleAutorisee && !(isCamilleAutorisee &&
                    selObjetMessage.code=='INFO_REC'))" class="text-left">
                        Suite à l'envoi de votre mail, vous allez recevoir un accusé de réception. Si tel n'est pas le cas, merci de vérifier l'adresse mail enregistrée dans « Mon Profil ».
                    </p>
                    <div class="col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-0">
                        <button id="button-quitter" type="button" class="btn btn-form-cnaf btn-block btn-secondaire-cnaf align-middle-cnaf"
                            (click)="confirmerClick()"
                            >
                            Quitter
                        </button>
                    </div>
                    <div class="col-xs-8 col-xs-offset-2 col-sm-4 col-sm-offset-4">
                        <button type="submit" *ngIf="selObjetMessage && !selObjetMessageIsEmptyJson && !selObjetMessage.hasChildren" class="btn btn-form-cnaf btn-block btn-active-cnaf align-middle-cnaf"
                            [attr.disabled]="isDisabled? 'disabled' : null"
                        >
                            {{isCamilleAutorisee && selObjetMessage && !selObjetMessageIsEmptyJson && selObjetMessage.code!='INFO_REC' ? 'Soumettre'
                            : 'Envoyer'}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div *ngSwitchCase="'reponsesCamille'" id="conteneur-reponses">
            <router-outlet [hidden]="!((currentRoute() === '/contactcafcourriel/reponses') && selObjetMessage.code!='INFO_REC')"></router-outlet>
        </div>
    </div>
</div>
